import React from 'react';
import clsx from 'clsx';

interface Props {
    additionalClasses?: string[];
    label: React.ReactNode;
    url: string;
    location?: string;
    children: React.ReactNode;
}

export default function TopLevelNavigationDetachedDropdownItem({
    location = 'down-left',
    additionalClasses = [],
    url,
    label,
    children,
}: Props) {
    return (
        <div
            className={clsx('top-level-nav__item', ...additionalClasses)}
            data-global-nav-detached-dropdown
            data-detached-dropdown
            data-detached-dropdown-location={location}
            data-detached-dropdown-location-forced
        >
            <a
                className="top-level-nav__item__link"
                href={url}
                data-no-link
                data-detached-dropdown-trigger
            >
                {label}
                <span className="icon icon--down-2 icon--offset-left icon--inline" />
            </a>
            <div data-detached-dropdown-content>
                <div data-detached-dropdown-content-inner="">{children}</div>
            </div>
        </div>
    );
}
